<div class="cookie-content">
  <svg-icon src="/assets/icons/icons-cookies.svg"></svg-icon>

  <h6>{{ 'GA.COOKIE_INFO.TITLE' | translate }}</h6>
  <p>{{ 'GA.COOKIE_INFO.DESCRIPTION' | translate }}</p>
  <div class="buttons">
    <ui-button-rectangle
      (click)="onDeclineClick()"
      type="secondary"
      label="{{ 'GA.COOKIE_INFO.BUTTON.NO' | translate }}"
    ></ui-button-rectangle>
    <ui-button-rectangle
      [forceFullWidth]="true"
      (click)="onAcceptClick()"
      type="primary"
      label="{{ 'GA.COOKIE_INFO.BUTTON.ACCEPT' | translate }}"
    ></ui-button-rectangle>
  </div>
</div>
